// config.js
export const BASE_URL = 'https://med-hw59.onrender.com'; // Replace with your actual URL
